import React from "react";

const Middlebar = () => {
  return (
    <div className=" hidden w-full lg:flex md:flex-shrink justify-center">
      <div className="w-[45%] py-3 flex items-center">
        <img src="header.jpeg"  alt="logo" className="w-800 selection:items-center mx-14 mb-1 my-1" />
        {/* <h1 className="font-bold font-arial tracking-wider text-left text-black ">
          <span className="text-5xl ">EMAAN INSTITUTE</span>
          <br />
          <span className="text-2xl tracking-wide mx-3">
            OF MANAGEMENT AND SCIENCES
          </span>
        </h1> */}
      </div>
    </div>
  );
};

export default Middlebar;
